import axios from "axios";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Label, Form } from "reactstrap";
import { environment, myBucket, S3_BUCKET, BuildingLink } from "../../env";
import ErrorComponents from "../errorComponents/ErrorComponents";
import { useDispatch, useSelector } from "react-redux";
import { loaderAction, successModalToggle } from "../../redux/actions/Index";
import { debounce } from "lodash";
import { useCallback } from "react";
import { Phone } from 'react-telephone';
import { useMemo } from "react";
import TitleCase from "../../Helper/TitleCase";
import { PencilLine } from '@phosphor-icons/react';
import { toast } from "react-toastify";

function InvestorModal({ update, button, data, id,editfunction,query }, ...props) {
  const [modal, setModal] = useState(false);
  const [btndis, setBtndis] = useState(true);
  const [auto, setAuto] = useState(true);
  const [editt, setEdit] = useState(true);
  const [ID, setID] = useState();
  const [imgerror, setImgerror] = useState();
  const [contecterr, setContecterr] = useState(false);
  const [aadharerror, setAadharerror] = useState(true);
  const [galafilterData, setgalafilterData] = useState();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [panerror, setPanError] = useState('');
  const [buildings, setBuildings] = useState([])
  const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
  const preventNegativeValuesspi = (e) => ["+", "-", "!", "@", "#", "$", "%", "^", "&", "*", "=", "/", "_"].includes(e.key) && e.preventDefault()
  const toggle = () => {
    reset({});
    setModal(!modal);
    setImgerror();
    setBtndis(true)
  }
  const dispatch = useDispatch();
  const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
  const galaList = useSelector((state) => state?.ModalReducer?.galaList);
  const userProject = useSelector((state) => state?.ModalReducer?.userproject);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const ImageURL = watch("image");
  const NAME = watch("name");
  var pann = watch("pan_no")
  const BuildingWatch = watch("building");
  const number = watch("contact_number")
  const email = watch("email")
  const address = watch("address")
  const corsp_address = watch("corsp_address")
  const aadhar_no = watch("aadhar_no")
  const gst = watch("gst")
  const gala = watch("gala")

  useEffect(()=>{
    setBtndis(true)
  },[ImageURL,NAME,pann,BuildingWatch,number,email,address,corsp_address,aadhar_no,gst,gala])


  useMemo(() => {
    if (ImageURL?.length > 0) {
      setImgerror(ImageURL[0].name)
      setBtndis(true);
    }

  }, [ImageURL, NAME])

  useMemo(() => {
    if (BuildingWatch) {
      var galaFilter = galaList?.filter((item) => item?.building?.id == BuildingWatch)
      galaFilter = galaFilter?.sort((a, b) => (a?.gala_no || 0) - (b?.gala_no || 0))
      setgalafilterData(galaFilter)
    }
  }, [BuildingWatch, userProject, galaList])

  useMemo(() => {
    if (buildingList) {
      var bldgFilter = buildingList?.filter((item) => item?.project?.id == userProject)
      bldgFilter = bldgFilter?.sort((a, b) => (a.building_no > b.building_no) ? 1 : ((b.building_no > a.building_no) ? -1 : 0))
      setBuildings(bldgFilter)
    }
  }, [buildingList, userProject])

  const debounce = useCallback(
    _.debounce((_searchVal) => {
      if (_searchVal == "") {
        setAadharerror();
        setBtndis(true);
      } else if (_searchVal.length != 12) {
        setAadharerror("Aadhar Number needs to be 12 numbers ");
        setBtndis(false);
      } else {
        setBtndis(true);
        setAadharerror();
      }
    }, 1000),
    []
  );

  const Image = (data, date) => {
    if (data?.length != 0) {

      const params = {
        ACL: "public-read",
        Body: data[0],
        Bucket: S3_BUCKET,
        Key: `${date}_${data[0].name}`,
      };
      myBucket.upload(params, function (err, uploadData) {
        if (uploadData) {
          return uploadData.Location
        } else {
          console.log("error", err);
        }
      });
      return
    }
  };

  const onSubmit = async (data) => {
    setBtndis(false);
    dispatch(loaderAction(true))
    setContecterr(false)
    if (data.contact_number.length !== 13) {
      setContecterr(true)
      setBtndis(true)
      return;
    }
    const InvestorPayload = new FormData();
    var date = Math.round(+new Date() / 1000);
    if (data?.image?.length != 0) {
      Image(data?.image, date)
      InvestorPayload.append("image", `${BuildingLink}${date}_${data?.image[0].name}`);
    }
    InvestorPayload.append("name", data?.name);
    InvestorPayload.append("email", data?.email);
    InvestorPayload.append("contact_number", data.contact_number);
    InvestorPayload.append("address", data?.address);
    InvestorPayload.append("corsp_address", data?.corsp_address);
    InvestorPayload.append("gst", data?.gst);
    InvestorPayload.append("aadhar_no", data?.aadhar_no);
    InvestorPayload.append("pan_no", data?.pan_no);
    InvestorPayload.append("building", data?.building);
    InvestorPayload.append("gala", data?.gala);
    try {
      await axios
        .post(`${environment.baseUrl}investor/`, InvestorPayload)
        .then((form) => {
          if (form.data.message == "Investor created successfully") {
            dispatch(successModalToggle());
            update(auto);
            setAuto(!auto)
            reset();
            toggle();
            setBtndis(false);
            dispatch(loaderAction(true))
          } else {
            toast.error(form.data.message, {
              position: toast.POSITION.TOP_CENTER
            });
          }
          
        });
        
      } catch (err) {
      setBtndis(false);
      dispatch(loaderAction(false))
      console.log(err);
    }
  };

  const checkGst = (data) => {
    let flag = false
    if (data.length > 0) {
      if (pann != undefined && data.length == 15) {
        for (let i = 2; i < 12; i++) {
          if (data[i].toUpperCase() != pann[i - 2].toUpperCase()) {
            flag = true
          }
        }
      } else {
        flag = true
      }
    } else if (data.length == 0) {
      flag = false
    }


    if (flag == true) {
      setPanError('Please Enter Correct GST Number')
      setBtndis(false)
    } else {
      setPanError('')
      setBtndis(true)
    }
  }

  const EditSubmit = async (data) => {
    if (id == undefined) {
      return;
    }
    setBtndis(false);
    setContecterr(false)
    if (data.contact_number.length !== 13) {
      setContecterr(true)
      setBtndis(true)
      return;
    }
    const InvestorPayload = new FormData();
    InvestorPayload.append("name", data?.name);
    InvestorPayload.append("email", data?.email);
    InvestorPayload.append("contact_number", data?.contact_number);
    InvestorPayload.append("address", data?.address);
    InvestorPayload.append("corsp_address", data?.corsp_address);
    InvestorPayload.append("gst", data?.gst);
    InvestorPayload.append("aadhar_no", data?.aadhar_no);
    InvestorPayload.append("pan_no", data?.pan_no);
    InvestorPayload.append("building", data?.building);
    InvestorPayload.append("gala", data?.gala);
    var date = Math.round(+new Date() / 1000);
    if (data?.image?.length != 0) {
      Image(data?.image, date)
      InvestorPayload.append("image", `${BuildingLink}${date}_${data?.image[0].name}`);
    }
    dispatch(loaderAction());
    try {
      await axios
        .put(
          `${environment.baseUrl}editinvestor/${id}`,
          InvestorPayload
        )
        .then((form) => {
          if (form.data.code === 200) {
            dispatch(successModalToggle());
            editfunction(query);
            dispatch(loaderAction(false));
            reset(data);
            setBtndis(true);
            toggle();
          } else {
            setBtndis(true);
            toast.error(form.data.message, {
                position: toast.POSITION.TOP_CENTER
            });
          }
        });
    } catch (err) {
      dispatch(loaderAction(false));
      console.log(err);
      setBtndis(true);

    }
  };

  useMemo(() => {
    setID(ID);
    reset(
      {
        "name": data?.name,
        "email": data?.email,
        "address": data?.address,
        "corsp_address": data?.corsp_address,
        "contact_number": data?.contact_number,
        "gst": data?.gst,
        "building": data?.building?.id,
        "gala": data?.gala?.id,
        "gst": data?.gst == "null" ? "" : data?.gst,
        "aadhar_no": data?.aadhar_no,
        "pan_no": data?.pan_no,
      },
    );
    setPhoneNumber(data?.contact_number)
    setImgerror(data?.image.split("com/", 2)[1])
  }, [editt]);

  const handelContactBlur = (number) => {
      setValue("contact_number",number)
      setContecterr(false)
      if(number.length != 13){
          setContecterr(true)
    }
};

  useEffect(() => {

  }, [galaList, buildingList])

  return (
    <>
      {" "}
      {button == "create" ? (
        <Button
          onClick={toggle}
          className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5 mb-5"
        >
          <span className="fs-3 d-flex gap-3 title-font-600 px-3">
            Create Investors
          </span>
        </Button>
      ) : (
        <button
          onClick={() => { setModal(!modal); setEdit(!editt) }}
          className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' />
        </button>
      )}
      <Modal
        className="border-0"
        isOpen={modal}
        toggle={props.toggle}
        size="lg"
        centered
      >
        <ModalHeader className="bg-base-color ">
          <span className="title-font-700 fs-36 text-base-white">
            {button == "create" ? "Create Investor" : "Edit Investor"}
          </span>
        </ModalHeader>
        <Form
          onSubmit={
            button == "create"
              ? handleSubmit(onSubmit)
              : handleSubmit(EditSubmit)
          }
        >
          <ModalBody className="bg-background-color px-5">
            <div className="row">
              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                  Party Name *
                </Label>
                <br />
                <div className="mt-1 d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    autoComplete="off"
                    placeholder="Enter Party Name..."
                    {...register("name", { required: true, onChange: (e) => TitleCase(e) })}
                  />
                </div>
                {errors.name && (
                  <ErrorComponents error={"Party name is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                  Contact Number *
                </Label>
                <br />
                <div className='mt-1  d-flex gap-3'>
                  <Phone {...register('contact_number', {required: true})} onChange={(e) => (handelContactBlur(e.target.value))} value={phoneNumber} defaultCountry="in" className='d-flex border-radius-10 shadow-none px-4  w-100 fs-4 title-font-500 fs-2 modal-input bg-white py-3'>
                    <Phone.Country className='fs-4 border-0 w-35 border-end' />
                    <Phone.Number placeholder="1234567890" value={data?.contact_number} className=' ps-2 w-75 fs-4 title-font-500  border-0' />
                  </Phone>
                </div>
                {(contecterr || errors.contact_number) && <ErrorComponents error={'Enter Valid Contact Number'} />}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                  Email *
                </Label>
                <br />
                <div className="mt-1 d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="email"
                    placeholder="Enter Email...."
                    {...register("email", {
                      required: "Email is required *", pattern: {
                        value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                        message: "Enter valid email"
                      }
                    })}
                  />
                </div>
                {errors.email && (
                  <ErrorComponents error={errors.email.message} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                  Permanent  Address
                </Label>
                <br />
                <div className="mt-1 d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    autoComplete="off"
                    min={0}
                    placeholder="Enter Address..."
                    {...register("address")}
                  />
                </div>
                {errors.address && (
                  <ErrorComponents error={"Address is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                  Correspondence  Address
                </Label>
                <br />
                <div className="mt-1 d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    autoComplete="off"
                    min={0}
                    placeholder="Enter Address..."
                    {...register("corsp_address")}
                  />
                </div>
                {errors.address && (
                  <ErrorComponents error={"Address is required *"} />
                )}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                  Aadhaar Number
                </Label>
                <br />
                <div className="mt-1 d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="number"
                    placeholder="Adhar Numbers..."
                    maxLength={12}
                    min={0}
                    autoComplete="off"
                    onKeyDown={preventNegativeValues}
                    {...register("aadhar_no", {
                      onChange: (e) => {
                        debounce(e.target.value);
                      },
                    })}
                  />
                </div>
                {errors.aadhar_no && (
                  <ErrorComponents error={"Aadhaar number is required *"} />
                )}
                {aadharerror && <ErrorComponents error={aadharerror} />}
                {/* <br /> */}
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                  PAN Number *
                </Label>
                <br />
                <div className="mt-1 d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    type="text"
                    autoComplete="off"
                    onKeyDown={preventNegativeValuesspi}
                    placeholder="Enter PAN Number..."
                    maxLength={10}
                    {...register("pan_no", {
                      required: "Pan Number is required *",
                      pattern: {
                        value: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
                        message: "Enter valid Pan No"
                      },
                      onChange: (e) => { e.target.value = e.target.value.toUpperCase(); console.log(e.target.value) }
                    })}
                  />
                </div>
                {errors.pan_no && (
                  <ErrorComponents error={errors.pan_no.message} />
                )}
                {/* <br /> */}
              </div>

              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                  GST Number
                </Label>
                <br />
                <div className="mt-1 d-flex gap-3">
                  <input
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input text-uppercase"
                    type="text"
                    maxLength={15}
                    min={0}
                    onKeyDown={preventNegativeValuesspi}
                    autoComplete="off"
                    placeholder="GST Number..."
                    {...register("gst", { onChange: (e) => { e.target.value = e.target.value.toUpperCase() }, onBlur: (e) => { checkGst(e.target.value) } })}
                  />
                </div>
                {errors.gst && (
                  <ErrorComponents error={"GST number is required *"} />
                )}
                {panerror && (
                  <ErrorComponents error={panerror} />
                )}
                <br />
              </div>
              <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                  Building*
                </Label>
                <br />
                <div className='mt-1  d-flex gap-3'>
                  <select
                    id="building"
                    name="building"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("building", { required: "Please Select Building" })}
                  >
                    <option value="">Select Building</option>
                    {
                      buildings?.map((item, i) => <option value={item?.id} key={i}>{item?.building_no}</option>)
                    }
                  </select>
                </div>
                {errors.building && (<ErrorComponents error={errors.building.message} />)}
                <br />
              </div>
              <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                  Gala *
                </Label>
                <br />
                <div className='mt-1  d-flex gap-3'>
                  <select
                    id="gala"
                    name="gala"
                    className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("gala", { required: "Please Select Gala" })}
                  >
                    <option value="">Select Gala</option>
                    {
                      galafilterData?.map((item, i) => <option value={item?.id} key={i}>{item?.gala_no}</option>)
                    }
                  </select>
                </div>
                {errors.gala && (<ErrorComponents error={errors.gala.message} />)}
                <br />
              </div>
              <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                  Profile Pic
                </Label>
                <br />
                <div className="mt-1 d-flex gap-3">
                  <input
                    className="border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input bg-white"
                    type="file"
                    placeholder="Upload Images..."
                    {...(props.button == "create"
                      ? { ...register("image") }
                      : { ...register("image") })}
                  />
                </div>
                {imgerror && <div className="row align-items-center justify-content-between gap-2 my-3 px-3">
                  <div className="buttons p-3 mx-1  rounded-2 w-100">
                    <h4 className="mb-0 base-font-500 fs-4 text-dotted">{imgerror}</h4>
                  </div>
                </div>}
                <br />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              className="border-radius-7 p-3 d-flex align-items-center buttons-outline"
              onClick={toggle}
            >
              <span className="fs-5 d-flex gap-3 title-font-600 px-3">
                Cancel
              </span>
            </Button>{" "}
            <Button
              className="border-radius-7 p-3 d-flex align-items-center buttons"
              disabled={!btndis}
            >
              <span className="fs-5 d-flex gap-3 title-font-600 px-3">
                Save
              </span>
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}

export default InvestorModal;